export class UnidadesConversao
{
  unidadeFrom: string;
  unidadeTo: string;
  unidadeConversao: number;
}
